import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  content: {
    fontWeight: 'bold'
  },
  button: {
    backgroundColor: theme.baseUI.color,
    border: `1px solid ${theme.baseUI.color}`,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.baseUI.color
    }
  },
  buttonWrapper: {
    margin: '0 5px 5px 0'
  }
}));
